export default "__VITE_ASSET__XWOwiUrn__"